import { ReactNode, useEffect } from 'react'
import { useBigBrother } from '../../../contexts/providers/BigBrotherProvider'
import { IVerticalBlockItem, IVideo } from '../../../types'

type Props = {
  video: IVideo
  children?: ReactNode
  bbProps: {
    anchorId: string
    index: number
    isTimeLine: boolean
    isBigBrother: boolean
    title: string
    time: string
  }
}

const BigBrotherVideoRegister = ({ bbProps, children, video }: Props) => {
  const { registerVideo } = useBigBrother()

  useEffect(() => {
    // only register once per kalturaId (or use another unique key if you prefer)
    const reel: IVerticalBlockItem = {
      link: '',
      video: video,
      title: bbProps?.title,
      poster: video.poster,
      time: bbProps?.time,
      link_title: '',
    }
    registerVideo({
      index: bbProps?.index,
      anchorId: bbProps?.anchorId,
      ...reel,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerVideo, video.kalturaId])

  return <>{children}</>
}

export default BigBrotherVideoRegister
